import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import React,{Component} from 'react';

// 监听滚动
class App extends Component{
    constructor() {
      super();
      this.state = {
        className_1: 'hidden_left',
        className_2: 'hidden_right',
        className_3: 'hidden_left',
        className_4: 'hidden_right',
        className_5: 'hidden_left'
      };
    }
    handleScroll(){
      if (document.documentElement.scrollTop > 800) {
        this.setState({
          className_1: 'show_left'
        });
      }
      if (document.documentElement.scrollTop > 1500) {
        this.setState({
          className_2: 'show_right'
        });
      }
      if (document.documentElement.scrollTop > 2300) {
        this.setState({
          className_3: 'show_left'
        });
      }
      if (document.documentElement.scrollTop > 3300) {
        this.setState({
          className_4: 'show_right'
        });
      }
      if (document.documentElement.scrollTop > 3900) {
        this.setState({
          className_5: 'show_left'
        });
      }
    }
    componentDidMount(){
      window.onscroll = () => this.handleScroll();
    }

    render(){
      return (

      <div className="App">
        <Banner />
        <div className='back_wrap'>
          <div className='homepagelayer'>
            <img src="https://static.igem.wiki/teams/4298/wiki/home-1.png" className={this.state.className_1} />
            <h3>Humans have been fighting against bacteria since the dawn of time.For the first tens of thousands of years, such struggles often ended in failure, massive death and profound disaster.</h3>
          </div>
          <div class="clear"></div>
          <div className='homepagelayerr'>
            <img src="https://static.igem.wiki/teams/4298/wiki/home-2.png" className={this.state.className_2}/>
            <h3>The Black Death, broken in the Middle Age, almost killed 1/3 of European people.The crow mask may have been the first human attempt to fight the plague, although whether it was reliable is debatable.</h3>
          </div>
          <div class="clear"></div>
          <div className='homepagelayer_special'>
            <img src="https://static.igem.wiki/teams/4298/wiki/home-3.png" className={this.state.className_3} />
            <h3>Alexander Fleming first discovered an antibiotic known as penicillin in 1928. This miracle substance, which inhibits the growth and reproduction of bacteria, gave mankind hope in the enduring battle against bacteria.</h3>
          </div>
          <div class="clear"></div>
          <div className='back_wrap_2'>
            <div className='homepagelayerr'>
              <img src="https://static.igem.wiki/teams/4298/wiki/home-4.png" className={this.state.className_4} />
              <h3>Nowadays, 162,000 tons of antibiotics were used in China to protect people from bacterial infections. Without antibiotics, mankind would never be as prosperous as it is today.</h3>
            </div>
            <div class="clear"></div>
            <div className='homepagelayer'>
              <img src="https://static.igem.wiki/teams/4298/wiki/home-5.png" className={this.state.className_5} />
              <h1><font>But...... </font></h1>
            </div>
          </div>
          <div class="clear"></div>
          <div className='homepagelayerx'>
            <h3>Bacteria are also evolving to defend themselves against this kind of wonder drug that has allowed humans to prosper for nearly a century. Now, if without action, humanity is likely to return to that dark age when plagues were prevalent and no medicine was available. This is known as </h3>
            <h1><b><font size="10" color="red">ANTIBIOTIC CRISIS</font></b></h1>
            <img src="https://static.igem.wiki/teams/4298/wiki/antibody-evolution.png" />
            <br></br>
            <br></br>
            <br></br>
            <br></br>

          </div>
        </div>
        <div class="clear"></div>
        <Skills />
        <div className='homepagelayert'>
          <img src="https://static.igem.wiki/teams/4298/wiki/home-7.png" />
          <h3>This year, we aimed to develop a standardized modular short-peptide EPI optimization procedure based on directed evolution and Yeast-E.coli co-culture system. Through this procedure, as long as we know the structure of an efflux pump, we could generate an efficient EPI that could been synthesized by microorganisms easily——DEEPI, a new solution to the antibiotic crisis!</h3>
        </div>

      </div>
    );
  }
}


export default App;
//<Projects />
